var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .5C3.87.5.5 3.92.5 8.113c0 1.177.475 2.468 1.13 3.83.657 1.367 1.513 2.795 2.374 4.097 1.71 2.611 3.416 4.734 3.416 4.734L8 21.5l.58-.726s1.705-2.123 3.422-4.734c.855-1.302 1.71-2.73 2.367-4.097.656-1.362 1.131-2.653 1.131-3.83C15.5 3.92 12.13.5 8 .5Zm0 1.523c3.322 0 6 2.717 6 6.09 0 .713-.37 1.897-.979 3.164-.609 1.272-1.44 2.652-2.267 3.925C9.377 17.295 8.439 18.449 8 19.008c-.44-.559-1.377-1.713-2.754-3.806-.826-1.273-1.658-2.653-2.267-3.925C2.369 10.01 2 8.827 2 8.113c0-3.373 2.678-6.09 6-6.09ZM8 6.59c-.826 0-1.5.684-1.5 1.523 0 .838.674 1.522 1.5 1.522s1.5-.684 1.5-1.522c0-.839-.674-1.523-1.5-1.523Z",
    fill: "#111"
  })));
};

export default SvgLocation;